import { render, staticRenderFns } from "./quiz-summary.html?vue&type=template&id=3b4addcc&scoped=true&"
import script from "./quiz-summary.vue?vue&type=script&lang=js&"
export * from "./quiz-summary.vue?vue&type=script&lang=js&"
import style0 from "./quiz-summary.css?vue&type=style&index=0&id=3b4addcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4addcc",
  null
  
)

export default component.exports